var videoWrapperone = document.querySelector(".onlyimgvd1");
var vidone = document.querySelector(".videoprovd1 video");
var vidoverleyone = document.querySelector(".videooverlay2");
var videobtnone = document.querySelector(".videoplay2");
document.querySelector(".video-imgsecone")?.addEventListener("click", (e) => {
  if (vidone.paused) {
    if (videoWrapperone) videoWrapperone.style.opacity = "0";

    vidone.play();
    if (vidoverleyone.querySelector(".product-type")) {
      vidoverleyone.querySelector(".product-type").style.opacity = "0";
    }
    if (vidoverleyone.querySelector(".product-title")) {
      vidoverleyone.querySelector(".product-title").style.opacity = "0";
    }
    videobtnone.querySelector(".text").innerText = "PAUSE";
    videobtnone.querySelector(".pause-icon").style.display = "block";
    videobtnone.querySelector(".play-icon").style.display = "none";
  } else {
    if (vidoverleyone.querySelector(".product-type")) {
      vidoverleyone.querySelector(".product-type").style.opacity = "1";
    }
    if (vidoverleyone.querySelector(".product-title")) {
      vidoverleyone.querySelector(".product-title").style.opacity = "1";
    }
    videobtnone.querySelector(".text").innerText = "PLAY";
    videobtnone.querySelector(".pause-icon").style.display = "none";
    videobtnone.querySelector(".play-icon").style.display = "block";
    vidone.pause();
  }
});
